import { styled } from 'styled-components';
import { Button as CustomButton } from '@/shared/ui/form/button';

export const Wrapper = styled.div`
  border-radius: 8px;
  background: #27262b;
  padding: 20px 32px 20px 20px;
  margin: 16px 0;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    display: block;
    padding: 20px 16px;
    background-color: transparent;
  }
`;
export const AccountWrapper = styled(Wrapper)`
  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const ImageWrapper = styled.div`
  width: 104px;
  height: 104px;
  border-radius: 50%;
  overflow: hidden;
  display: inline-block;
  background-color: #f0f0f0;

  @media (max-width: 768px) {
    width: 80px;
    height: 80px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    background-color: transparent;
  }
`;

export const AvatarWrapper = styled(ImageWrapper)`
  background-color: #3d383f;
`;

export const DropzoneContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 240px;
  border-radius: 10px;
  cursor: pointer;
  overflow: hidden;
  margin-top: 32px;
  margin-bottom: 32px;
  border: 1px solid #131315;
  background-image: url('/images/background/background_profile_edit_img.svg');
  background-repeat: no-repeat;
  background-size: cover; /* или 100% auto */
  background-position: center;

  @media (max-width: 768px) {
    height: 75%;
  }
`;
export const Avatar = styled.img`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  object-fit: cover;
`;

export const Content = styled.div`
  text-align: center;
  cursor: pointer;
`;

export const Icon = styled.div`
  font-size: 2rem;
  margin-bottom: 10px;
`;

export const Text = styled.p`
  margin: 0;
  font-size: 1rem;
`;

export const Or = styled.p`
  margin: 10px 0;
  font-size: 0.9rem;
  color: #888;
`;

export const Button = styled.button`
  display: flex;
  padding: 10px 20px;
  gap: 8px;
  border-radius: 55px;
  background: var(--edeff-5, #edeff5);
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.2) inset;
  border: none;
  margin: 0 auto;
  cursor: pointer;
`;

export const DropzoneWrapper = styled.div`
  width: 364px;
  margin: 0 auto;
  background-color: #131315;
  padding: 32px 24px;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
`;

export const Badge = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 11;
  border-radius: 32px;
  border: 3px solid #27262b;
  background: #ff9500;
`;

export const PencilWrapper = styled.div`
  cursor: pointer;
`;

export const IconButton = styled(CustomButton)`
  // padding: 3px;
  border-radius: 8px;
  display: block;
  flex: none;
`;

export const FormIconButton = styled(CustomButton)`
  ${IconButton};
  padding: 0 12px;
  height: 48px;
`;

export const NameInput = styled.input`
  border: none;
  background-color: transparent;
  color: #edeff5;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  font-size: 24px;
  box-sizing: border-box;
  outline: none;
`;

export const NameInputWrapper = styled.div``;

export const SecuritySettingsWrapper = styled.div`
  border-radius: 8px;
  // background: #1b202d;
  background: #27262b;
  padding: 32px 20px;
  margin-top: 4px;

  ${({ $flat }) =>
    $flat &&
    `
    border-radius: 0px;
    border-top: 1px solid #27262B;
    border-bottom: 1px solid #27262B;

    `}
  ${({ $top }) =>
    $top &&
    `
    border-radius: 8px 8px 0 0;

    `}
  ${({ $down }) =>
    $down &&
    `
    border-radius: 0 0 8px 8px ;
    `}

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const SecuritySettingsContainer = styled.div`
  margin-top: 12px;
`;
export const SecuritySettingsContainer4Top = styled.div`
  margin-top: 4px;
`;

export const IconButtonWrapper = styled.div`
  border-radius: 8px;
  background: #4b444c;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
  display: flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
`;

export const IconPencilWrapper = styled.div`
  position: absolute;
  cursor: pointer;
  right: 12px;
  top: 12px;
`;
export const InputWithButtons = styled.div`
  display: flex;
  width: 412px;
  margin-top: 0;
  position: relative;
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 12px;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
  }
`;
